module.exports = __webpack_public_path__ + "static/img/10.8608814.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/10.png
// module id = qRBS
// module chunks = 0